<template>
  <div class="reward-modal">
    <van-overlay :show="visible" :lock-scroll="true" :z-index="300">
      <div class="wrapper" @click.stop>
        <div class="card">
          <div class="title">请选择一个您需要的权益</div>
          <div class="options">
            <div
              class="option"
              :class="{ active: selectedIndex === item.equityType }"
              v-for="(item, index) in options"
              :key="index"
              @click="selectedIndex = item.equityType"
            >
              <div class="name">{{ item.name }}</div>
              <div v-show="selectedIndex === item.equityType" class="check"></div>
            </div>
          </div>
          <img
            :class="['confirm-btn', { 'Grade56Btn': [5,6].includes(rewardParms?.gradeNum) }]"
            :src="require('@/assets/imgs/promotionGift/rewardBtn.png')"
            @click="onConfirm"
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { xibEnhanceReceive } from '@/api/xibPromotionGift'
import { generateLink2 } from '@/api/communal'
// 档位与权益选项映射（gradeNum: 1-6）
const GRADE_OPTIONS_MAP = {
  1: [
    { name: '25 元微信立减金', equityType: 1 },
    { name: '25 元京东e卡', equityType: 2 },
    { name: '1288 商城积分', equityType: 3 }
  ],
  2: [
    { name: '60 元微信立减金', equityType: 1 },
    { name: '60 元京东e卡', equityType: 2 },
    { name: '3088 商城积分', equityType: 3 }
  ],
  3: [
    { name: '80 元微信立减金', equityType: 1 },
    { name: '80 元京东e卡', equityType: 2 },
    { name: '4088 商城积分', equityType: 3 }
  ],
  4: [
    { name: '120 元微信立减金', equityType: 1 },
    { name: '120 元京东e卡', equityType: 2 },
    { name: '6088 商城积分', equityType: 3 }
  ],
  5: [
    { name: '200 元微信立减金', equityType: 1 },
    { name: '200 元京东e卡', equityType: 2 },
    { name: '10088 商城积分', equityType: 3 },
  ],
  6: [
    { name: '400 元微信立减金', equityType: 1 },
    { name: '400 元京东e卡', equityType: 2 },
    { name: '20088 商城积分', equityType: 3 },
  ]
}
export default {
  name: 'RewardModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rewardParms: {
      type: Object,
      default: () => ({})
      // gradeNum 档位
      // openId
      // appId
    }
  },
  data() {
    return {
      selectedIndex: 1, // 当前选中的权益索引
      options: [] // 动态权益
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.loadOptionsByGrade()
          this.selectedIndex = 1
        }
      },
      immediate: true
    }
  },
  methods: {
    // 根据档位加载权益选项
    loadOptionsByGrade() {
      const gradeNum = this.rewardParms?.gradeNum
      this.options = GRADE_OPTIONS_MAP[gradeNum] || []
    },
    async onConfirm() {
      const selectedEquityType = +this.selectedIndex // 已选中权益类型
      const rewardParms = this.rewardParms // 领取权益参数gradeNum，openId，appId
      // 如果没有微信openId则跳转到小程序去做领取
      if (selectedEquityType === 1 && !rewardParms.openId) {
        this.jumpWxDetail()
        return
      }

      const { data } = await xibEnhanceReceive({
        ...rewardParms,
        equityType: selectedEquityType // 权益类型：1-微信立减金 2-京东e卡 3-商城积分 4-手机话费充值卡
      })
      this.$emit('confirm')
      // result"发放结果：1-成功，0-失败"
      if (data.result === 1) {
        this.$router.push({
          path: '/xiameBankPromotionGiftDetail',
          query: { ...data }
        })
      } else {
        this.$router.push({ path: '/xiameBankPromotionGiftFailDetail' })
      }
    },
    // 跳转微信小程序内嵌厦门国际银行微信详情页领取立减金
    async jumpWxDetail() {
      const urlToken = sessionStorage.getItem('xiameBankPromotionJhToken')
      const rewardParms = this.rewardParms
      const url = `${process.env.VUE_APP_H5_PREFIX_URL}ydsh-ph-h5-bankv3/xiameBankPromotionGiftWxDetail?urlToken=${urlToken}&gradeNum=${rewardParms.gradeNum}`
      // window.location.href = url
      const { data } = await generateLink2({
        link: encodeURIComponent(url)
      })
      window.location.href = data.urlLink
    }
  }
}
</script>

<style lang="less" scoped>
.reward-modal {
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    box-sizing: border-box;
  }
  .card {
    width: 375px;
    height: 404px;
    background: url('~@/assets/imgs/promotionGift/rewardBg.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      margin-top: 62px;
      font-size: 16px;
      color: #000000;
    }
    .options {
      width: 202px;
      margin-top: 18px;
      .option {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 48px;
        border-radius: 10px;
        background: #ffffff;
        margin-bottom: 7px;
        padding: 0 16px;
        box-sizing: border-box;
        color: #1c0960;
        border: solid 1px #ffb979;
        font-size: 14px;
        &.active {
          border: 1px solid #995eff;
        }
        .check {
          width: 20px;
          height: 16px;
          background: url('~@/assets/imgs/promotionGift/rewardCheck.png')
            no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .confirm-btn {
      width: 150px;
      height: 42px;
      margin-top: 20px;
      &.Grade56Btn {
        margin-top: 46px;
      }
    }
  }
}
</style>
